<script>
  import Logo from './Logo.svelte';

  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { name: 'Pricing', href: '/pricing' },
      { name: 'Resources', href: '/resources' },
      { name: 'FAQ', href: '/faq' }
    ],
    company: [
      { name: 'About', href: '/about' },
      { name: 'Contact', href: '/contact' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' }
    ]
  };
</script>

<footer class="bg-slate-50 border-t border-slate-200">
  <div class="container-wide py-16">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
      <!-- Brand Column -->
      <div class="col-span-2 md:col-span-1">
        <div class="mb-4">
          <Logo size="small" />
        </div>
        <p class="text-slate-500 text-sm leading-relaxed max-w-xs">
          Control how AI models perceive and recommend your business.
        </p>
      </div>

      <!-- Product Links -->
      <div>
        <h4 class="text-slate-900 font-semibold mb-4">Product</h4>
        <ul class="space-y-3">
          {#each footerLinks.product as item}
            <li>
              <a href={item.href} class="text-slate-500 hover:text-slate-900 text-sm transition-colors">{item.name}</a>
            </li>
          {/each}
        </ul>
      </div>

      <!-- Company Links -->
      <div>
        <h4 class="text-slate-900 font-semibold mb-4">Company</h4>
        <ul class="space-y-3">
          {#each footerLinks.company as item}
            <li>
              <a href={item.href} class="text-slate-500 hover:text-slate-900 text-sm transition-colors">{item.name}</a>
            </li>
          {/each}
        </ul>
      </div>

      <!-- Legal Links -->
      <div>
        <h4 class="text-slate-900 font-semibold mb-4">Legal</h4>
        <ul class="space-y-3">
          {#each footerLinks.legal as item}
            <li>
              <a href={item.href} class="text-slate-500 hover:text-slate-900 text-sm transition-colors">{item.name}</a>
            </li>
          {/each}
        </ul>
      </div>
    </div>
  </div>

  <!-- Bottom Bar -->
  <div class="border-t border-slate-200">
    <div class="container-wide py-6">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p class="text-slate-400 text-sm">
          &copy; {currentYear} LLMTxtBuilder. All rights reserved.
        </p>
        <div class="flex items-center gap-2 text-sm text-slate-400">
          <span class="w-2 h-2 rounded-full bg-brand-500 animate-pulse"></span>
          <span>All systems operational</span>
        </div>
      </div>
    </div>
  </div>
</footer>
